"use client";
import { useState, useEffect, useMemo } from "react";
import Image from "next/image";
import Link from "next/link";

// importing redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/GlobalRedux/Store";
import {
  FILTER_POSTS,
} from "@/app/GlobalRedux/features/post/postSlice";

import { MdReadMore } from "react-icons/md";
import { TiTime } from "react-icons/ti";

import ReactPaginate from "react-paginate";

import { formattedDate } from "@/app/utils/date-format/formatDate";

import BlogNavigation from "@/app/blog/Components/BlogNavigation";

import styling from "@/app/blog/Components/GeneralBlogStyles.module.scss";
import Loader from "@/app/(Global)/Components/Loader";
import { useGetAllViewablePostsQuery } from "@/app/GlobalRedux/features/post/postApi";
import { PostData } from "@/app/GlobalRedux/features/post/postInterfaces";
// import { AiFillEye } from "react-icons/ai";

const TechTrendArticle = () => {
  const dispatch = useDispatch();
  const [searchWord, setSearchWord] = useState("");

  // from postApi
  const { data, isLoading: isLoadingPost } =
    useGetAllViewablePostsQuery(undefined);

  // Memoize posts to avoid unnecessary recomputations
  const posts: PostData[] = useMemo(() => data?.posts || [], [data]);
  // from post and auth slice
  const { filteredposts } = useSelector((state: RootState) => state.post);

  useEffect(() => {
    // Filter the posts to include only those with postStatus: "Published"
    const publishedPosts = posts.filter(
      (post) => post.postStatus === "Published"
    );
    dispatch(FILTER_POSTS({ publishedPosts, searchWord }));
  }, [dispatch, searchWord, posts]);


  const techTrendPosts = [...filteredposts].filter((post) =>
    post.postCategories.includes("Tech Trend")
  );

  // Begin Pagination
  const itemsPerPage = 4;
  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + itemsPerPage;
  const currentPagePosts = techTrendPosts.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(techTrendPosts.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % techTrendPosts.length;
    setItemOffset(newOffset);
  };
  // End Pagination


  return (
    <>
      <main className={`${styling.blog}`}>
        <aside>
          <BlogNavigation />

          <div className={styling.search}>
            <input
              type="text"
              name="Search"
              id="Search"
              placeholder="Search post by title or words"
              value={searchWord}
              onChange={(e) => setSearchWord(e.target.value)}
            />
          </div>
        </aside>

        {isLoadingPost ? (
          <Loader />
        ) : (
          <>
            {currentPagePosts.length === 0 ? (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "1.2rem",
                  margin: "1rem 0",
                  backgroundColor: "#040245",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "8px",
                  padding: "1rem",
                  color: "#fff",
                }}
              >
                No post found
              </p>
            ) : (
              <section className={styling.blog__mainblog}>
                {currentPagePosts.map((post) => {
                  const postPreviewContent = post.metaDescription.slice(0, 250);
                  return (
                    <div
                      className={styling.blog__mainblog__container}
                      key={post._id}
                    >
                      <div className={styling.blog__mainblog__container__top}>
                        <Image
                          src={post.featuredImage}
                          alt="Featured Image"
                          width={450}
                          height={450}
                        />
                        <div
                          className={
                            styling.blog__mainblog__container__top__glass
                          }
                        >
                          <div>
                            <p>{formattedDate(post.publishedAt)}</p>
                            <p
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              {/* {post.allViews} <AiFillEye size={20} /> */}
                            </p>
                          </div>
                          <div>
                            <p>
                              <span>
                                <TiTime />
                              </span>
                              {post.readTime} mins read
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* topic */}
                      <div
                        className={styling.blog__mainblog__container__bottom}
                      >
                        <h2>{post.title}</h2>
                        <p>{postPreviewContent}...</p>
                        <div
                          className={
                            styling.blog__mainblog__container__bottom__B
                          }
                        >
                          <Link href={`/blog/${post.slug}`}>
                            Read More
                            <span
                              style={{
                                marginLeft: "8px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <MdReadMore />
                            </span>
                          </Link>
                          <div>
                            <p>{post.shareCount} shares</p>
                            <li>
                              {post.topicTags.map((tags) => {
                                return <span key={tags}>{tags}</span>;
                              })}
                            </li>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </section>
            )}
          </>
        )}

        <ReactPaginate
          breakLabel="..."
          nextLabel="Next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="Prev"
          renderOnZeroPageCount={null}
          containerClassName="pagination"
          pageLinkClassName="page-num"
          previousLinkClassName="page-num"
          nextLinkClassName="page-num"
          activeLinkClassName="activePage"
        />
      </main>
    </>
  );
};

export default TechTrendArticle;
